import { Button, Space } from "antd";

interface IncomingFBCallControlsProps {
  callState: "incoming" | "connecting" | "connected" | "ended";
  isMuted: boolean;
  isSpeakerOn: boolean;
  isProcessing: boolean;
  onAccept: () => void;
  onReject: () => void;
  onTerminate: () => void;
  onToggleMute: () => void;
  onToggleSpeaker: () => void;
}

export const IncomingFBCallControls = ({
  callState,
  isMuted,
  isSpeakerOn,
  isProcessing,
  onAccept,
  onReject,
  onTerminate,
  onToggleMute,
  onToggleSpeaker,
}: IncomingFBCallControlsProps) => {
  const renderIncomingControls = () => (
    <Space>
      <Button
        type="primary"
        size="small"
        icon={<i className="ri-phone-line"></i>}
        onClick={onAccept}
        loading={isProcessing}
        className="bg-green-500 border-green-500 hover:bg-green-600"
      >
        Accept
      </Button>
      <Button
        danger
        size="small"
        icon={<i className="ri-phone-off-line"></i>}
        onClick={onReject}
        loading={isProcessing}
      >
        Reject
      </Button>
    </Space>
  );

  const renderConnectedControls = () => (
    <Space>
      <Button
        type={isMuted ? "default" : "primary"}
        size="small"
        icon={<i className={isMuted ? "ri-mic-off-line" : "ri-mic-line"}></i>}
        onClick={onToggleMute}
        disabled={isProcessing}
      >
        {isMuted ? "Unmute" : "Mute"}
      </Button>

      <Button
        type={isSpeakerOn ? "primary" : "default"}
        size="small"
        icon={<i className="ri-volume-up-line"></i>}
        onClick={onToggleSpeaker}
        disabled={isProcessing}
      >
        Speaker
      </Button>

      <Button
        danger
        size="small"
        icon={<i className="ri-phone-off-line"></i>}
        onClick={onTerminate}
        loading={isProcessing}
      >
        End Call
      </Button>
    </Space>
  );

  const renderConnectingControls = () => (
    <Space>
      <Button
        size="small"
        icon={<i className="ri-loader-4-line animate-spin"></i>}
        disabled
      >
        Connecting...
      </Button>
      <Button
        danger
        size="small"
        icon={<i className="ri-phone-off-line"></i>}
        onClick={onReject}
        loading={isProcessing}
      >
        Cancel
      </Button>
    </Space>
  );

  const renderEndedControls = () => (
    <div className="text-center text-gray-500 text-sm">Call ended</div>
  );

  switch (callState) {
    case "incoming":
      return renderIncomingControls();
    case "connecting":
      return renderConnectingControls();
    case "connected":
      return renderConnectedControls();
    case "ended":
      return renderEndedControls();
    default:
      return null;
  }
};
